export const COOKIE_CONSENT_KEY = 'cookieConsent';
// Bump when purposes/providers change: old choices must not authorize new trackers.
export const COOKIE_CONSENT_VERSION = 2;
export const COOKIE_CONSENT_MAX_AGE = 180 * 24 * 60 * 60 * 1000;
export const OPEN_COOKIE_NOTICE = 'flwrk:open-cookie-notice';
export const COOKIE_CONSENT_CHANGED = 'flwrk:cookie-consent-changed';
export const NECESSARY_ONLY = Object.freeze({ necessary: true, analytics: false, marketing: false });
let storageFailed = false;

export function getCookieConsent(now = Date.now()) {
  if (storageFailed) return null;
  try {
    const value = JSON.parse(window.localStorage.getItem(COOKIE_CONSENT_KEY));
    const timestamp = typeof value?.timestamp === 'string' ? Date.parse(value.timestamp) : NaN;
    if (value?.version !== COOKIE_CONSENT_VERSION || value.necessary !== true
      || typeof value.analytics !== 'boolean' || typeof value.marketing !== 'boolean'
      || !Number.isFinite(timestamp) || timestamp > now || now - timestamp >= COOKIE_CONSENT_MAX_AGE) return null;
    return { ...NECESSARY_ONLY, analytics: value.analytics, marketing: value.marketing, version: value.version, timestamp: value.timestamp };
  } catch {
    return null;
  }
}

export function getCookiePreferences() {
  const consent = getCookieConsent();
  return { ...NECESSARY_ONLY, analytics: consent?.analytics === true, marketing: consent?.marketing === true };
}

// Every future optional integration must check this BEFORE loading its script.
// The analytics adapter uses this gate; marketing remains unintegrated.
export function hasCookieConsent(category) {
  return getCookiePreferences()[category] === true;
}

export function saveCookieConsent(preferences) {
  const consent = {
    necessary: true,
    analytics: preferences.analytics === true,
    marketing: preferences.marketing === true,
    timestamp: new Date().toISOString(),
    version: COOKIE_CONSENT_VERSION,
  };
  try {
    window.localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consent));
    storageFailed = false;
  } catch {
    storageFailed = true;
    // Do not leave an earlier grant active after a failed withdrawal.
    try { window.localStorage.removeItem(COOKIE_CONSENT_KEY); } catch { /* Storage unavailable. */ }
    window.dispatchEvent(new Event(COOKIE_CONSENT_CHANGED));
    return false;
  }
  window.dispatchEvent(new Event(COOKIE_CONSENT_CHANGED));
  return true;
}

// Integrations can respond to withdrawal as well as changes made in another tab.
export function subscribeCookieConsent(listener) {
  const update = () => listener(getCookiePreferences());
  const storage = event => {
    if (event.key === COOKIE_CONSENT_KEY || event.key === null) update();
  };
  window.addEventListener(COOKIE_CONSENT_CHANGED, update);
  window.addEventListener('storage', storage);
  return () => {
    window.removeEventListener(COOKIE_CONSENT_CHANGED, update);
    window.removeEventListener('storage', storage);
  };
}

export function openCookieNotice() {
  window.dispatchEvent(new Event(OPEN_COOKIE_NOTICE));
}
